export default __webpack_public_path__ + "static/media/other_type.feb54cf7.svg";